"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MetaView", {
    enumerable: true,
    get: function() {
        return MetaView;
    }
});
const _core = require("@fxts/core");
const _runets = require("rune-ts");
const _constants = require("../constants");
const _manifest = require("../manifest");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _tagged_template_literal([
        "<title>",
        "</title>"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        '<meta name="description" content="',
        '" />'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n      <!doctype html>\n\n      <html ",
        ">\n        <head>\n          ",
        " ",
        " ",
        "\n          ",
        "\n          ",
        " ",
        '\n        </head>\n        <body>\n          <div id="body">',
        "</div>\n          <div>",
        "</div>\n        </body>\n        ",
        "\n      </html>\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
/*
   * html에 들어가는 attribute를 지정할 수 있습니다. id는 pc, mo 둘 중 하나로 강제됩니다. 기본 값은 pc입니다.
   * */ /*
   * head에 들어갈 태그들을 설정할 수 있습니다. title, description은 필수 입니다.
   * */ /*
     * 추가적인 스크립트를 설정할 수 있습니다.
     * */ const toStrReduce = (pre, val)=>"".concat(pre).concat(val);
const strMap = (iter, fn)=>{
    return (0, _core.pipe)(iter, (0, _core.map)((v)=>fn(v)), (0, _core.reduce)(toStrReduce));
};
const createTags = (tag_data, makeTagFunction)=>{
    return _runets.html.preventEscape((0, _core.pipe)(tag_data, (0, _core.map)((meta_tag)=>makeTagFunction((0, _core.entries)(meta_tag))), (0, _core.reduce)(toStrReduce)));
};
const createAttributes = (attributes)=>{
    if (attributes) {
        return _runets.html.preventEscape((0, _core.pipe)(attributes, _core.entries, (entry)=>strMap(entry, (param)=>{
                let [key, value] = param;
                return " ".concat(key, '="').concat(value, '"');
            })));
    }
    return _runets.html.preventEscape('');
};
const createOGTags = (og_tags)=>{
    if (og_tags) {
        return createTags(og_tags, (entry)=>{
            return "<meta ".concat(strMap(entry, (param)=>{
                let [key, value] = param;
                if (key === 'property') {
                    value = 'og:' + value;
                }
                return " ".concat(key, '="').concat(value, '"');
            }), " />");
        });
    }
    return _runets.html.preventEscape('');
};
const createMetaTags = (meta_tags)=>{
    if (meta_tags) {
        return createTags(meta_tags, (entry)=>{
            return "<meta ".concat(strMap(entry, (param)=>{
                let [key, value] = param;
                return " ".concat(key, '="').concat(value, '"');
            }), " />");
        });
    }
    return _runets.html.preventEscape('');
};
const createLinkTag = (link_tags)=>{
    if (link_tags) {
        return createTags(link_tags, (entry)=>{
            return "<link ".concat(strMap(entry, (param)=>{
                let [key, value] = param;
                return " ".concat(key, '="').concat(value, '"');
            }), " />");
        });
    }
    return _runets.html.preventEscape('');
};
const createScriptTag = (scripts)=>{
    if (scripts) {
        return createTags(scripts, (entry)=>{
            return "<script ".concat(strMap(entry, (param)=>{
                let [key, value] = param;
                return " ".concat(key, '="').concat(value, '"');
            }), " ></script>");
        });
    }
    return _runets.html.preventEscape('');
};
const createStyleSheetTag = (manifest)=>(style_sheet)=>{
        manifest = manifest !== null && manifest !== void 0 ? manifest : {};
        const file = manifest[style_sheet];
        return file ? '<link rel="stylesheet" href="'.concat(manifest[style_sheet], '" />') : '';
    };
const createJsEntryTag = (manifest)=>(js_file_name)=>{
        manifest = manifest !== null && manifest !== void 0 ? manifest : {};
        const file = manifest[js_file_name];
        return file ? '<script crossorigin="anonymous" src="'.concat(manifest[js_file_name], '"></script>') : '';
    };
class MetaView extends _runets.Layout {
    template(data) {
        var _data_head, _data_head1;
        return (0, _runets.html)(_templateObject2(), this.htmlAttribute, this.openGraph, this.meta, ((_data_head = data.head) === null || _data_head === void 0 ? void 0 : _data_head.title) ? (0, _runets.html)(_templateObject(), data.head.title) : '', ((_data_head1 = data.head) === null || _data_head1 === void 0 ? void 0 : _data_head1.description) ? (0, _runets.html)(_templateObject1(), data.head.description) : '', this.link, this.styleSheet, this.page.toHtmlSSR(), this.entryScript, this.extraScript);
    }
    constructor(page, data){
        var _data_head, _data_head1, _data_head2, _data_body;
        super(data, page);
        _define_property(this, "htmlAttribute", void 0);
        _define_property(this, "openGraph", void 0);
        _define_property(this, "meta", void 0);
        _define_property(this, "link", void 0);
        _define_property(this, "styleSheet", void 0);
        _define_property(this, "entryScript", void 0);
        _define_property(this, "extraScript", void 0);
        this.htmlAttribute = createAttributes(data.html);
        this.openGraph = createOGTags((_data_head = data.head) === null || _data_head === void 0 ? void 0 : _data_head.open_graph_tags);
        this.meta = createMetaTags((_data_head1 = data.head) === null || _data_head1 === void 0 ? void 0 : _data_head1.meta_tags);
        this.link = createLinkTag((_data_head2 = data.head) === null || _data_head2 === void 0 ? void 0 : _data_head2.link_tags);
        this.extraScript = createScriptTag((_data_body = data.body) === null || _data_body === void 0 ? void 0 : _data_body.scripts);
        const manifest = (0, _manifest.getManifest)();
        this.styleSheet = _runets.html.preventEscape("\n      ".concat(strMap(_constants.STYLE_SHEET_FILES, createStyleSheetTag(manifest)), "\n    "));
        this.entryScript = _runets.html.preventEscape("\n      ".concat(strMap(_constants.JS_FILES, createJsEntryTag(manifest)), "\n    "));
    }
}
